import { createSelector } from '@ngrx/store';
import {
  selectCurrentLicenseName,
  selectIsCurrentSubscriptionLoaded,
} from './current/current.selectors';
import {
  selectProducts,
  selectIsProductsLoaded,
  selectIsProductsLoading,
} from './products/products.selectors';

export { selectCurrentLicenseName, selectProducts, selectIsProductsLoading };

export const selectIsSubscriptionLoaded = createSelector(
  selectIsCurrentSubscriptionLoaded,
  selectIsProductsLoaded,
  (current, products) => current && products
);

export const selectIsFreemium = createSelector(
  selectCurrentLicenseName,
  (license) => (license ? license === 'Freemium' : true)
);
export const selectCanUpgrade = createSelector(
  selectProducts,
  selectCurrentLicenseName,
  selectIsFreemium,
  (products, current, isFreemium) => {
    const availableProducts = products.filter((p) => p.name !== current);
    return isFreemium && availableProducts.length > 0;
  }
);
